import { TagSpecialProps } from '@sbercloud/uikit-product-site-tag/src/components/TagSpecial/TagSpecial';
import React from 'react';
import {
  CategoryElement,
  CategoryElementItem,
  ProductCategory as ProductCategoryCatalogMain,
} from 'src/components/SectionCatalogMain/src/types';

import {
  CatalogProduct,
  CatalogProductType,
  ProductCategory,
} from '../../../../../types/backendContent';

type ClickElement = (
  event: React.MouseEvent<HTMLDivElement | HTMLAnchorElement, MouseEvent>,
  href: string,
  title: string,
  productType: CatalogProductType,
) => void;

type MapProductWithCategories = {
  categoriesByPlatform: ProductCategory[];
  titleFilter: string;
  searched: CatalogProduct[];
  productsItems: CatalogProduct[];
  platformFilter?: string;
  onClickElement: ClickElement;
};

const categoriesList = [
  {
    id: 'products',
    label: 'Сервисы',
    maxLength: 4,
  },
  {
    id: 'solutions',
    label: 'Решения',
    maxLength: 2,
  },
];

const mapArrayForCategoryElementItem =
  (onClickElement: ClickElement) =>
  (product: CatalogProduct): CategoryElementItem => {
    const currentHref = `/${product.type}/${product.slug}`;

    const href = product.customLink ? `/${product.customLink}` : currentHref;

    return {
      title: product.title,
      description: product.description,
      href,
      icon: {
        src: product.icon || '/plugs/product-2d-icon-default.svg',
        alt: product.title,
      },
      tags: (product.tags ?? []) as TagSpecialProps[],
      onClick: (e) => {
        onClickElement(e, href, product.title, product.type);
      },
    };
  };

const isElementApproachForPlatformAndCategory =
  (titleFilter: string, categoryId?: string, platformFilter?: string) =>
  (product: CatalogProduct) =>
    product.categories?.find(
      // Проверка: подходит ли категория под выбранную и есть ли поиск
      (cat) => cat.id === categoryId || titleFilter.length !== 0,
    ) &&
    product.productPlatforms.find(
      // Если platformFilter пустой, то мы считаем, что мы не должны фильтровать
      (platform) => platform.slug === platformFilter || !platformFilter,
    );

export function mapProductWithCategories({
  categoriesByPlatform,
  titleFilter,
  searched,
  productsItems,
  platformFilter,
  onClickElement,
}: MapProductWithCategories): ProductCategoryCatalogMain[] {
  return categoriesByPlatform.map((category) => {
    // Первый элемент дерева
    const list: Array<CategoryElement> = [];
    categoriesList.forEach((categoryList) => {
      // Todo: неправильно работает useElasticProductsSearch, когда пофиксится, изменить searchItems.filters... на searched
      const searchItems = titleFilter.length > 0 ? searched : productsItems;

      const items = searchItems
        .filter(
          isElementApproachForPlatformAndCategory(
            titleFilter,
            category?.id,
            platformFilter,
          ),
        )
        .filter((product) => product.type === categoryList.id)
        .map(mapArrayForCategoryElementItem(onClickElement));

      if (items.length) {
        list.push({
          id: categoryList.id,
          label: categoryList.label,
          maxLength: categoryList.maxLength,
          items,
        });
      }
    });
    return {
      id: category.id,
      label: category.title,
      labelQuery: category.slug,
      list,
    };
  });
}
